import {initialState} from '../state';
import { BpmnDisplayActionsTypes, UpdateTreeNavigationConfAction } from '../actions';
import { TreeNavigationConfiguration } from '../../models/tree-navigation-configuration';

export function treeNavigationConf(state = initialState.treeNavigationConf, action: UpdateTreeNavigationConfAction): TreeNavigationConfiguration {
  switch (action.type) {
    case BpmnDisplayActionsTypes.UPDATE_TREE_NAVIGATION_CONF:
      return action.payload.treeNavigationConf;
    default:
      return state;
  }
}
